import { createTheme as createMuiTheme } from '@mui/material/styles';
import { typography } from './typography';
import { palette } from './palette';
import { createComponents } from './createComponents';

export const createTheme = ({ direction = 'ltr' } = {}) => {
	const theme = createMuiTheme({
		breakpoints: {
			values: {
				xs: 0,
				sm: 600,
				md: 900,
				lg: 1200,
				xl: 1536,
				'2xl': 1920
			}
		},
		typography,
		palette,
		components: createComponents(palette),
		direction
	});

	return theme;
};
